import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import {DashboardsService} from "../../services/dashboards.service";
import {WidgetDatasourceEnum} from "../../../enums/widget-datasource.enum";

require('./dashboard-services-table-view.scss');
@Component({
  standalone: false,
  selector: 'app-dashboard-services-table-view',
  templateUrl: './dashboard-services-table-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardServicesTableViewComponent implements OnInit {

  @Input() filters: any;
  @Input() isLeanData: boolean = false;
  @Output() onViewServiceRelatedTasks = new EventEmitter<any>();

  public services: any[];
  public tableCursor: string;
  public isLoadingData: boolean;

  constructor(@Inject(DashboardsService) private dashboardsService: DashboardsService, @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.getTableWidgetData(this._getQueryPayload());
  }

  getNextBatch() {
    if (this.tableCursor) {
      let filters = {
        ...this._getQueryPayload(),
        cursor: this.tableCursor
      };
      this.getTableWidgetData(filters, true)
    }
  }

  private getTableWidgetData(queryParams, isFetchNext?: boolean) {
    this.isLoadingData = true;
    this.dashboardsService.getDashboardWidgetData(WidgetDatasourceEnum.serviceDetails, queryParams).subscribe({
      next: (res) => {

        if (isFetchNext && this.services.length) {
          this.services = [...this.services, ...res.list];
        } else {
          this.services = res.list;
        }

        this.tableCursor = res.cursor;
      },
      complete: () => {
        this.isLoadingData = false;
        this.cdr.detectChanges();
      }
    })
  }

  private _getQueryPayload() {
    return {
      ...this.filters,
      limit: 20
    };
  }


}
